import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-angle-right-small',
  templateUrl: './angle-right-small.component.html',
  styleUrls: ['./angle-right-small.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AngleRightSmallIconComponent {}
